// src/scripts/authMode.js
import { db } from "@/firebase";
import { doc, getDoc } from "firebase/firestore";
import { assertUserIsAllowed } from "@/scripts/authGate";

const LS_MODE = "coredeck_access_mode";

function lower(s) {
  return String(s ?? "").trim().toLowerCase();
}

export function setCachedMode(mode) {
  try {
    localStorage.setItem(LS_MODE, String(mode || ""));
  } catch {}
}

export function getCachedMode() {
  try {
    return localStorage.getItem(LS_MODE) || null;
  } catch {
    return null;
  }
}

export async function resolveAccessMode(user) {
  if (!user) return { mode: "none" };

  // ✅ 1) Privileged claims => full
  try {
    const token = await user.getIdTokenResult(true);
    if (token?.claims?.admin === true || token?.claims?.operations === true) {
      return { mode: "full" };
    }
  } catch {}

  // ✅ 2) If user is allowlisted as a full user, FULL wins (never overridden by rota docs)
  try {
    await assertUserIsAllowed(user);
    return { mode: "full" };
  } catch {
    // not allowlisted -> continue
  }

  // ✅ 3) users/{uid} explicit rota flags
  try {
    const usnap = await getDoc(doc(db, "users", user.uid));
    if (usnap.exists()) {
      const d = usnap.data() || {};
      if (d.rota_view_only === true) return { mode: "rota_view_only" };
      const role = String(d.role ?? "").trim().toLowerCase();
      if (role === "rota_viewer" || role === "staff") return { mode: "rota_view_only" };
    }
  } catch {}

  // ✅ 4) rota_access_by_email fallback
  const email = lower(user.email);
  if (!email) return { mode: "none" };

  try {
    const asnap = await getDoc(doc(db, "rota_access_by_email", email));
    if (!asnap.exists()) return { mode: "none" };

    const a = asnap.data() || {};
    if (a.disabled === true) return { mode: "none" };
    if (a.rota_view_only === true) return { mode: "rota_view_only" };
  } catch {}

  return { mode: "none" };
}